import { ColumnMapping, ExcelProcessorConfig, HeaderConfig, ParsedExcelData, ValidationError } from '@/lib/excel';
import type { GroupInput } from '@/types/schemas';

export const HEADERS = {
  MA_NHOM: 'Mã nhóm*',
  TEN_NHOM: 'Tên nhóm*',
  TEN_KHAC: 'Tên khác',
  TRANG_THAI: 'Trạng thái'
} as const;

export type ImportBody = Pick<GroupInput, 'ma_nhom' | 'ten_phan_nhom' | 'ten2' | 'trang_thai'>;

const HEADER_CONFIG: HeaderConfig[] = [
  { header: HEADERS.MA_NHOM, key: 'ma_nhom', type: 'main' },
  { header: HEADERS.TEN_NHOM, key: 'ten_phan_nhom', type: 'main' },
  { header: HEADERS.TEN_KHAC, key: 'ten2', type: 'main' },
  { header: HEADERS.TRANG_THAI, key: 'trang_thai', type: 'main' }
];

const toStringOrNull = (value: unknown): string | null => {
  if (value === null || value === undefined) return null;
  const str = String(value).trim();
  return str === '' ? null : str;
};

const UUIDPayload = (_parsedData: ParsedExcelData): { main: Record<string, never> } => {
  return {
    main: {}
  };
};

const ValidateUUID = (_response: unknown, _columnMapping: Record<string, ColumnMapping>): ValidationError[] => {
  return [];
};

const TransformToBodies = (
  _dataRows: unknown[][],
  parsedData: ParsedExcelData,
  _UUIDResponse: unknown,
  _context: unknown
): ImportBody[] => {
  const mainData = parsedData.main || {};
  const rowCount = (mainData.ma_nhom || []).length;
  const bodies: ImportBody[] = [];

  for (let i = 0; i < rowCount; i++) {
    const rawStatus = toStringOrNull(mainData.trang_thai?.[i] ?? '');
    let status = '1';
    if (rawStatus === '0' || rawStatus === 'Không sử dụng' || rawStatus?.toLowerCase() === 'inactive') {
      status = '0';
    }

    const body: ImportBody = {
      ma_nhom: toStringOrNull(mainData.ma_nhom?.[i] ?? '') || '',
      ten_phan_nhom: toStringOrNull(mainData.ten_phan_nhom?.[i] ?? '') || '',
      ten2: toStringOrNull(mainData.ten2?.[i] ?? ''),
      trang_thai: status
    };
    bodies.push(body);
  }

  return bodies;
};

export const ExcelConfig: ExcelProcessorConfig<ImportBody> = {
  Headers: HEADERS,
  HeaderConfig: HEADER_CONFIG,
  Transform: TransformToBodies,
  UUIDPayload,
  ValidateUUID
};
